import { datadogRum } from '@datadog/browser-rum';
import type { LDClient, LDFlagSet } from 'launchdarkly-js-client-sdk';

export function initializeLaunchDarklyDatadogIntegration(ldClient: LDClient) {
  let hasTrackedInitialFlags = false;

  const trackFeatureFlagEvaluation = (flagKey: string, value: unknown) => {
    datadogRum.addFeatureFlagEvaluation(flagKey, value);
  };

  const trackAllFlags = () => {
    // Prevent duplicate tracking on initialization
    if (hasTrackedInitialFlags) {
      return;
    }
    hasTrackedInitialFlags = true;

    const allFlags = ldClient.allFlags() as LDFlagSet;

    for (const [flagKey, flagValue] of Object.entries(allFlags)) {
      trackFeatureFlagEvaluation(flagKey, flagValue);
    }
  };

  const changeHandler = (changed: Record<string, unknown>) => {
    for (const [flagKey, details] of Object.entries(changed)) {
      if (details && typeof details === 'object' && 'current' in details) {
        const currentValue = (details as { current: unknown }).current;
        trackFeatureFlagEvaluation(flagKey, currentValue);
      }
    }
  };

  const readyHandler = () => {
    trackAllFlags();
  };

  ldClient.on('change', changeHandler);
  ldClient.on('ready', readyHandler);

  // Track existing flags immediately if client is already ready
  // This covers the case where the client was initialized before this integration
  ldClient.waitForInitialization().then(() => {
    trackAllFlags();
  });

  // Return cleanup function
  return () => {
    ldClient.off('change', changeHandler);
    ldClient.off('ready', readyHandler);
  };
}
